import { useContext } from 'react';

import { UserContext, UserContextValue } from '../contexts/User';

const useUserContext = (): UserContextValue => useContext(UserContext);

export default useUserContext;
